module.exports = __webpack_public_path__ + "9fc04cf625f950536f94d41e02553377.png";